import React from 'react';

import { Card, CardTitle, CardBody, CardFooter } from '@patternfly/react-core';

import {ClientRepresentation} from "../API";


type Props = {
    accountConsole: ClientRepresentation
}

export const ConsoleCard: React.FC<Props> = ({accountConsole}) => {

    const onClickCard = () => {
        window.location.href = `/auth${accountConsole?.baseUrl}#/security/signingin`;
    }

    return (
        <Card isHoverable
              className="consoleCard"
              key={accountConsole?.baseUrl}
              id={'card-view-' + accountConsole?.baseUrl}
              onClick={onClickCard}
        >
            <CardTitle>
                <a href={`/auth${accountConsole?.baseUrl}#/security/signingin`}
                   className="consoleLink">
                    {accountConsole?.description? accountConsole?.description : accountConsole.baseUrl.replace(/\/realms\/([a-zA-Z0-9\-_]+)\/account\//g, "$1")}
                </a>
            </CardTitle>
            <CardBody/>
            <CardFooter/>
        </Card>
    );
}

export default ConsoleCard;
